<template>
  <div>
    <ReportMobileFrame
      v-if="$vuetify.breakpoint.smAndDown"
      :loading="isLoading"
      :empty="!isLoading && data.length === 0"
      empty-text="No stock data."
    >
      <div v-for="(cat, ci) in data" :key="cat.category || ci">
        <ReportGroupHeader :label="cat.category || 'Uncategorised'">
          <template #stats>
            <div class="stat">
              <span class="stat__label">Stock</span>
              <span class="stat__value">{{ cat.totalStock }}</span>
            </div>
            <div class="stat">
              <span class="stat__label">Total</span>
              <span class="stat__value">£{{ Number(cat.total || 0).toFixed(2) }}</span>
            </div>
          </template>
        </ReportGroupHeader>
        <ReportListRow v-for="product in cat.products" :key="product.id">
          <template #title>{{ product.name }}</template>
          <template #subtitle>{{ product.currentStockFormatted }}</template>
          <template #trailing>£{{ Number(product.total || 0).toFixed(2) }}</template>
        </ReportListRow>
      </div>

      <template #action>
        <v-btn block color="success" :loading="isLoading" x-large @click="exportExcel">
          <v-icon left>mdi-file-export-outline</v-icon>
          EXPORT REPORT
        </v-btn>
      </template>
    </ReportMobileFrame>

    <template v-else>
    <div class="d-flex mb-5">
      <v-btn type="button" color="primary" v-on:click="exportExcel()">
        EXPORT
      </v-btn>
    </div>

    <v-row>
      <v-data-table
        :headers="headers" :items="data" 
        :loading="isLoading" :items-per-page="-1"
        show-expand :expanded.sync="expanded" :single-expand="true"
        item-key="category" class="elevation-1 mt-5 flex-grow-1">

       <template v-slot:header.total="{ header }">
        {{ header.text }} 
        <span v-if="data.length > 0">
          (£{{ Math.round(data.map(d => d.total).reduce((sum, x) => sum + x) * 100) / 100 }})
        </span>
      </template>

        <template v-slot:[`item.total`]="{ item }">
          £{{ item.total.toFixed(2) }}
        </template>

        <template v-slot:expanded-item="{ headers, item }">
         
          <td :colspan="headers.length">
            <table class="sub-table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Stock</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tr v-for="product in item.products" v-bind:key="product.id">
                <td>{{ product.name }}</td>
                <td>{{ product.currentStockFormatted }}</td>
                <td>£{{ product.total.toFixed(2) }}</td>
              </tr>
            </table>
          </td>
      
        </template>

      </v-data-table>
    </v-row>
    </template>
  </div>
</template>

<script>
import ReportMobileFrame from '@/components/reports/ReportMobileFrame.vue';
import ReportGroupHeader from '@/components/reports/ReportGroupHeader.vue';
import ReportListRow from '@/components/reports/ReportListRow.vue';
import { reportService } from '@/services';
import { b64toBlob } from '@/helpers'
import { saveAs } from 'file-saver';
import { userService } from '@/services';
import router from "../../router";

export default {

  name: 'CurrentStock',
  components: {
    ReportMobileFrame,
    ReportGroupHeader,
    ReportListRow
  },
  data: vm => ({
    isLoading: false,
    data: [],
    expanded: [],
    headers: [
      { text: 'Category', align: 'start', sortable: true, filterable: true, value: 'category' },
      { text: 'Stock #', align: 'start', sortable: true, filterable: true, value: 'totalStock' },
      { text: 'Total', align: 'start', sortable: true, filterable: true, value: 'total' },
    ],
  }),
  created () {
    this.load();
  },
  methods: {
    async load() {
      this.isLoading = true;
      this.data = await reportService.getCurrentStockReport();
      console.log(this.data);
      this.isLoading = false;
    },

    exportExcel: async function() {
      this.isLoading = true;
      var response = await reportService.exportCurrentStockReport();
      if (response.status != 200) {
        alert("Error exporting");
        return;
      }

      var base64 = await response.json();
      const blob = b64toBlob(base64, 'application/vnd.ms-excel');
      saveAs(blob, 'Stock.xls');

      this.isLoading = false;
    },
  }
}
</script>

<style lang="scss" scoped>
  .sub-table {
    width: 50%;
    
    th {
      text-align: left;
      padding-top: 5px;
    }

    tr {
      td {
        border-bottom: 1px solid #CECECE;
      }
    }
  }
</style>
